export const FLAG_GETTING_CIRCUITS = 'FLAG_GETTING_CIRCUITS';
export const GET_CIRCUITS = 'GET_CIRCUITS';
export const CLEAR_CIRCUITS = 'CLEAR_CIRCUITS';
export const FLAG_CIRCUIT_ACTIVITY = 'FLAG_CIRCUIT_ACTIVITY';
export const GET_CIRCUIT = 'GET_CIRCUIT';
export const CLEAR_CIRCUIT = 'CLEAR_CIRCUIT';
export const POST_CIRCUIT = 'POST_CIRCUIT';
export const PUT_CIRCUIT = 'PUT_CIRCUIT';
